module.exports = __webpack_public_path__ + "fonts/Oswald-500-cyrillic-ext11.4bda5ee.woff2";